import { useCallback, useState } from "react"

import { Upload } from "lucide-react"
import { toast } from "sonner"

interface DocumentDropZoneProps {
    onDrop: (files: File[]) => void
    children: React.ReactNode
    className?: string
    multiple?: boolean
    isDragOver?: boolean
}
export function DocumentDropZone({ onDrop, children, className = "", multiple = false, isDragOver = false }: DocumentDropZoneProps) {
    const [dragCounter, setDragCounter] = useState(0)

    const handleDragEnter = useCallback((e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()
        setDragCounter(prev => prev + 1)
    }, [])

    const handleDragLeave = useCallback((e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()
        setDragCounter(prev => prev - 1)
    }, [])

    const handleDragOver = useCallback((e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()
    }, [])

    const handleDrop = useCallback((e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()
        setDragCounter(0)

        const files = Array.from(e.dataTransfer.files)
        if (files.length > 0) {
            if (!multiple && files.length > 1) {
                toast.error("Only one file allowed for reference document")
                return
            }
            onDrop(files)
        }
    }, [onDrop, multiple])

    const isActive = dragCounter > 0

    return (
        <div
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            className={`
                relative transition-all duration-200
                ${isActive ? "ring-2 ring-blue-500 ring-offset-2 bg-blue-50" : ""}
                ${className}
            `}
        >
            {children}
            {isActive && (
                <div className="absolute inset-0 bg-blue-500/10 border-2 border-dashed border-blue-500 rounded-lg flex items-center justify-center z-10">
                    <div className="text-blue-600 font-medium flex items-center gap-2">
                        <Upload className="size-5" />
                        Drop {multiple ? "documents" : "document"} here
                    </div>
                </div>
            )}
        </div>
    )
}